import { Modal, Paragraph, Title } from "@sicredi/react";
import { IModalAccountAgency } from "../model";
import { useContext } from "react";
import { ContextAPI } from "#/contextProver/ContextProver";
import { handleRefresh } from "../services";
import { ButtonLinkChevronRight } from "../../ButtonLinkChevronRight";
import { Line } from "../../Line";
import styles from "./styles.module.scss";

export const CadastroErro: React.FC<IModalAccountAgency> = ({
  isOpen,
  setIsOpen,
}) => {
  const { logout } = useContext(ContextAPI);

  const handleOnclick = (url: string) => {
    window.open(url, "_blank");
  };

  return (
    <div>
      <Modal
        title="Atualize seus dados de cadastro"
        onClose={async () => await handleRefresh(setIsOpen, logout)}
        show={isOpen}
        primaryButton={{
          children: "Voltar para tela inicial",
          onClick: async () => await handleRefresh(setIsOpen, logout),
        }}
      >
        <Paragraph>
          Após isso, será possível simular o consórcio. Confira nossos canais de
          atendimento disponíveis para você.
        </Paragraph>

        <div className={styles.container_view}>
          <div className={styles.title}>
            <Title as="h3" size="large">
              Central de Atendimento
            </Title>
          </div>
          <ButtonLinkChevronRight
            onClick={() => handleOnclick("tel:0800 724 4770")}
            text="0800 724 4770"
            marginTop={0}
          />
        </div>
        <Line />

        <div className={styles.container_view}>
          <div className={styles.title}>
            <Title as="h3" size="large">
              WhatsApp
            </Title>
          </div>
          <ButtonLinkChevronRight
            onClick={() =>
              handleOnclick("https://wa.me/555133584770/?text=Oi,%20Sicredi")
            }
            text="Enviar uma mensagem"
            marginTop={0}
          />
        </div>
        <Line />

        <div className={styles.container_view}>
          <div className={styles.title}>
            <Title as="h3" size="large">
              Contatos das agências
            </Title>
          </div>
          <ButtonLinkChevronRight
            onClick={() =>
              handleOnclick(
                "https://www.sicredi.com.br/site/localizar-agencia/"
              )
            }
            text="Localizar agência próxima"
            marginTop={0}
          />
        </div>
      </Modal>
    </div>
  );
};
